import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { accountsEnvironment } from './accounts-environment';

export function deleteUsersBulk(externalIds: string[]) {
  return fromFetch(
    new Request(accountsEnvironment.usersBulkUrl, {
      method: 'DELETE',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        externalIds,
      }),
    })
  ).pipe(ignoreData());
}
